// extracted by mini-css-extract-plugin
export default {"icon":"Detail_icon__+QIyP","name":"Detail_name__wNrMj"};